/* W72 STEP 8 — THE ACCOUNT'S FIVE PAGES AS ONE ROW UNDER THE TITLE (Fable's ruling 2026-09-25: the p8 still drew
 * `Your page · Notifications · Your data · What changed`; nothing exists behind `Notifications`, so it is not drawn —
 * we build nothing behind a word).
 *
 * The Library's tab grammar (`libraryTabs.ts`): links, each page its own address, `aria-current="page"` on the one you
 * are on. The ORDER is the order a coach meets them: the page clients find you by, the name the community sees, the
 * people asking to be coached, then the two trust pages.
 */
import { href } from "./route";
import { COMMUNITY_INCLUDED, COACH_PAGE_TAB } from "./communityFeature";

/** JOB 3 STEP 5 PAGE 6 — the group's ONE title, drawn once above the row on every account page (the Library's grammar: the
 *  section's name as the h1, the parts as the row, the current one marked). Each page's own h1 repeated its marked tab. */
export const SETTINGS_TITLE = "Settings";

export type AccountPart = "page" | "identity" | "requests" | "reminders" | "data" | "changes";

export const ACCOUNT_PARTS: readonly { part: AccountPart; label: string }[] = [
  { part: "page", label: "Your page" },
  { part: "identity", label: "Your public name" },
  { part: "requests", label: "Requests" },
  // W82 step 6 — the coach's own reminders, after the people asking to be coached and before the two trust pages.
  { part: "reminders", label: "Reminders" },
  { part: "data", label: "Your data" },
  { part: "changes", label: "What changed" },
];

/** 🔴 W120: the public name leaves with the Community (`COMMUNITY_INCLUDED`); `Requests` stays while a request is still
 *  PENDING (a doorbell rung before the page left must not vanish unanswered); `Your page` stays — it is mixed.
 *  JOB 3 STEP 5 PAGE 6: and while the coach STANDS on Requests — a row that marks nothing current says "you are nowhere". */
export function visibleAccountParts(pendingRequests: number, included: boolean = COMMUNITY_INCLUDED, current?: AccountPart): readonly { part: AccountPart; label: string }[] {
  if (included) return ACCOUNT_PARTS;
  return ACCOUNT_PARTS.filter(({ part }) => part !== "identity" && (part !== "requests" || pendingRequests > 0 || current === "requests"))
    .map((p) => (p.part === "page" ? { ...p, label: COACH_PAGE_TAB } : p));
}

export function accountTabs(current: AccountPart, pendingRequests = 0) {
  return visibleAccountParts(pendingRequests, COMMUNITY_INCLUDED, current).map(({ part, label }) => ({ part, label, href: href({ name: part }), current: part === current }));
}
